import { authedAxios } from "../utils/customHttpHeader";

const postChannelManager = async (payload, endpoint) => {
  try {
    const response = await authedAxios().post(endpoint, payload);
    return response.data;
  } catch (error) {
    return null;
  }
};

const getRoomsData = async (endpoint, queryParams) => {
  try {
    const response = await authedAxios().get(endpoint, {
      params: {
        ...queryParams,
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

/**
 * 🔵 Call SU Widget Config API
 * Backend endpoint: /su/widget-config?hotelId=xxxx
 */
const getSuWidgetConfig = async (hotelId) => {
  try {
    const response = await authedAxios().get(
      "/cm/su/widget/token",
      {
        params: { hotelId },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to get SU widget config", error);
    return null;
  }
};


export { postChannelManager, getRoomsData, getSuWidgetConfig };
